<template>
    <div class="flats-page">
        <div class="container">
            <div class="page-title" v-if="setup != null">
                <h1>{{ setup.page_titles.flats_title }}</h1>
            </div>
        </div>
        <flatsFilter v-if="filterCMSparams != null"></flatsFilter>
        <div class="container" v-if="filterCMSparams != null && flatsItemsArr != null && !isMobileChecker">
            <div class="items-controls">
                <flatsFindNum></flatsFindNum>
                <div class="controls">
                    <flatsShorting></flatsShorting>
                    <flatsViewBtns></flatsViewBtns>
                </div>
            </div>
        </div>
        <flatsListTable v-if="!isMobileChecker && filterCMSparams != null && flatsItemsArr != null && flatsListView == 'list'"></flatsListTable>
        <flatsItems v-if="filterCMSparams != null && flatsItemsArr != null"></flatsItems>
        <formPage></formPage>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    // import store from '@/store.js'
    import flatsFilter from '@/components/filters/flats-filter/flats-filter.vue'
    import flatsItems from '@/components/flats-page/flats-items.vue'
    import flatsListTable from '@/components/flats-page/flats-list-table.vue'
    import flatsFindNum from '@/components/flats-page/flats-find-num.vue'
    import flatsViewBtns from '@/components/flats-page/flats-view-btns.vue'
    import flatsShorting from '@/components/filters/flats-filter/shorting-filter.vue'
    import formPage from '@/components/forms/form-page.vue'
    export default {
        name: 'flats--page',
        components: {
            flatsFilter,
            flatsItems,
            flatsListTable,
            flatsFindNum,
            flatsViewBtns,
            flatsShorting,
            formPage,
        },
        metaInfo() {
            return {
                title: 'Надежный застройщик "DIAL GROUP" - Квартиры',
                meta: [
                    { name: 'description', content:  'Первичные квартиры комфорт-класса в Алмалинском районе от 24 000 000 тенге. В 10 минутах от MEGA Park. Готовые квартиры в ЖК бизнес-класса в золотом квадрате.'},
                ]
            };
        },
        data () {
            return {
                globalLang: window.GlobalLang, 
            }
        },
        computed: mapGetters({
            setup: 'loadPageSetUp',
            filterCMSparams: 'loadFilterCMSparams',
            flatsItemsArr: 'loadFlatsItems',
            flatsListView: 'loadFlatsListView',
            filterFlatsDataBase: 'loadFilterFlatsData',
            isOpenFilterMobile: 'loadOpenFlatsMobileFilter',
            isMobileChecker: 'loadIsMobileChecker',
            // aboutPage: 'loadAboutPage',
        }),
        methods: {
        },
        beforeCreate() {
            this.$store.dispatch('getFlatsItems');
            document.body.dataset.page = 'flats';
        },
        created () {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/flats-page/flats-page.scss';
    @import '@/styles/components/flats-page/respond/flats-page-respond.scss';
</style>